const PREFIX = "GLOBAL_ACTIONS_FOR_STORE_CHANGING"

export const SET_UPLOADER_OPTIONS = `${PREFIX}/SET_UPLOADER_OPTIONS`

export const types = { SET_UPLOADER_OPTIONS }

export const setUploaderOptions = (data) => ({ type: SET_UPLOADER_OPTIONS, data })
